<template>
    <DialogLayout>
        <div class="row">
            <div class="col-md-6 col-xs-12 m-b-30">
                <h3>{{ $props.event.title }}</h3>
                <hr>
                <div class="row m-t-30">
                    <div class="col-md-4">
                        <b class="d-block">Début</b>
                        <span>{{ $props.event.start_at_formatted }}</span>
                    </div>
                    <div class="col-md-4">
                        <b class="d-block">Fin</b>
                        <span>{{ $props.event.end_at_formatted }}</span>
                    </div>
                    <div class="col-md-4" v-if="!$props.event.unlimited_slots">
                        <b class="d-block">Nombre de places</b>
                        <span>{{ $props.event.max_participants }} ({{ $props.event.free_slots }} restantes)</span>
                    </div>
                </div>
                <div class="m-t-20" v-if="$props.event.description">
                    <b>Description</b>
                    <div class="m-t-20" v-html="$props.event.description"></div>
                </div>
            </div>
            <div class="col-md-6 col-xs-12">
                <h3>Participer</h3>
                <hr>
                <div class="m-t-30">
                    <form @submit.prevent="handleSubmit" v-if="$props.event.has_free_slots">
                        <div class="Alert Alert--error m-b-15" v-if="errorOccured">
                            Une erreur est survenue, veuillez réessayer.
                        </div>
                        <input-material @input="value => handleChange('firstname', value)" :required="true"
                                        label="Prénom"
                                        :error="errors.firstname" v-model="data.firstname"/>
                        <input-material @input="value => handleChange('lastname', value)" :required="true" label="Nom"
                                        :error="errors.lastname" v-model="data.lastname"/>
                        <input-material @input="value => handleChange('email', value)" :required="true"
                                        label="Adresse e-mail" type="email" :error="errors.email"
                                        v-model="data.email"/>
                        <div class="text-center m-t-30">
                            <button :disabled="sending" type="submit" class="Btn Btn--primary Btn--gradient Btn--shadow">
                                <i v-if="sending" class="fas fa-spinner fa-spin"></i>
                                <span v-else>Valider <i class="fas fa-caret-right m-l-5"></i></span>
                            </button>
                        </div>
                    </form>
                    <div v-else class="Alert Alert--primary m-b-15">
                        Il n'y a plus aucune place disponible.
                    </div>
                </div>
            </div>
        </div>
    </DialogLayout>
</template>
<script>
import InputMaterial from "../InputMaterial";
import 'vue-multiselect/dist/vue-multiselect.min.css';
import {actions} from "../../store";
import DialogLayout from "./Layouts/DialogLayout";
import validate from "../../validator/validator";
import Rules from "../../validator/rules";
import {isEmpty} from "../../utils";
import Api from "../../services/Api";
import ModalBus from "../../eventBus";
import Token from "../../services/Token";

export default {
    components: {DialogLayout, InputMaterial},
    props: {
        event: {
            type: Object,
            required: true
        }
    },
    data: function () {
        return {
            sending: false,
            errorOccured: false,
            data: {
                firstname: null,
                lastname: null,
                email: null,
            },
            errors: {}
        }
    },
    methods: {
        handleChange: function (name) {
            delete this.errors[name];
        },
        handleSubmit: async function () {
            const data = {...this.data};
            const errors = validate(data, {
                firstname: [Rules.required()],
                lastname: [Rules.required()],
                email: [Rules.required(), Rules.email()],
            });

            this.errorOccured = false;

            if (!isEmpty(errors)) {
                this.errors = errors;
                return;
            }

            this.sending = true;

            try {
                await this.$recaptchaLoaded();
                data['g-recaptcha-response'] = await this.$recaptcha('participate');

                await Api.post(`/events/${this.event.id}/participate`, data);
                ModalBus.alertSuccess('Participation enregistrée', 'Nous vous remercions de participer à cet événement.');
            } catch (err) {
                this.sending = false;
                if (err.response?.data?.errors) {
                    this.errors = err.response.data.errors;
                } else {
                    this.errorOccured = true;
                }
            }
        }
    },
    async created() {
        if (!this.$user && Token.has()) {
            await actions.fetchUser();
        }

        this.data = {
            ...this.data,
            firstname: this.$user?.profile?.firstname,
            lastname: this.$user?.profile?.lastname,
            email: this.$user?.email
        };
    }
}
</script>
